/* Enchantmints Wholesale — minimum order quantity (MOQ) enforcement.
   Client-side guard layer:
     - Per design: each line item must be at least CASE_PACK (4), then any quantity (4, 5, 6 …).
     - Opening order: cart subtotal must be >= MIN_CENTS ($250).
     - Product page: quantity input starts at CASE_PACK, steps by 1, minimum CASE_PACK.
   This is a display/UX guard. For a hard server-side stop, add a Shopify
   Cart & Checkout Validation Function later (noted in the build plan). */
(function () {
  'use strict';

  var CASE_PACK = 4;           // minimum units per design
  var MIN_CENTS = 25000;       // $250.00 opening order
  var MIN_LABEL = '$250.00';
  var lastSig = null;

  function cartUrl() {
    return (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
  }

  function isCartContext() {
    return !!document.querySelector('#main-cart-footer, cart-drawer, cart-items, #main-cart-items');
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[name="checkout"], #checkout, .cart__checkout-button')
    );
  }

  function messageEl() {
    var el = document.getElementById('wholesale-moq-message');
    if (!el) {
      el = document.createElement('div');
      el.id = 'wholesale-moq-message';
      el.className = 'wholesale-moq-message';
      el.setAttribute('role', 'status');
      el.hidden = true;
    }
    var anchor = document.querySelector('#cart-errors')
      || document.querySelector('.cart__ctas')
      || document.querySelector('cart-drawer .drawer__footer')
      || document.querySelector('.cart__footer');
    if (anchor && anchor.parentNode && el.parentNode !== anchor.parentNode) {
      anchor.parentNode.insertBefore(el, anchor);
    }
    return el;
  }

  function applyState(problems) {
    var sig = problems.join('||');
    var buttons = checkoutButtons();
    var block = problems.length > 0;

    // Keep button state in sync (Dawn re-renders these on cart updates).
    buttons.forEach(function (b) {
      var isBlocked = b.classList.contains('wholesale-blocked');
      if (block && !isBlocked) { b.classList.add('wholesale-blocked'); b.setAttribute('aria-disabled', 'true'); }
      if (!block && isBlocked) { b.classList.remove('wholesale-blocked'); b.removeAttribute('aria-disabled'); }
    });

    if (sig === lastSig) return; // avoid redundant DOM writes (and observer loops)
    lastSig = sig;

    var el = messageEl();
    if (block) {
      el.innerHTML = '<strong>Before you check out:</strong><ul>'
        + problems.map(function (p) { return '<li>' + p + '</li>'; }).join('')
        + '</ul>';
      el.hidden = false;
    } else {
      el.hidden = true;
      el.innerHTML = '';
    }
  }

  var inFlight = false;
  function validate() {
    if (!isCartContext()) return;
    if (inFlight) return;
    inFlight = true;
    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var problems = [];
        var count = cart.item_count || 0;
        (cart.items || []).forEach(function (item) {
          if (item.quantity < CASE_PACK) {
            problems.push(item.product_title + ' has a minimum of ' + CASE_PACK
              + ' per design — increase the quantity to at least ' + CASE_PACK + ' (currently ' + item.quantity + ').');
          }
        });
        var subtotal = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : cart.total_price;
        if (count > 0 && subtotal < MIN_CENTS) {
          problems.push('Opening order minimum is ' + MIN_LABEL + '. Add ' + money(MIN_CENTS - subtotal) + ' more to check out.');
        }
        applyState(problems);
      })
      .catch(function () { applyState([]); }) // fail open on network error
      .finally(function () { inFlight = false; });
  }

  // Final guard: stop a blocked checkout click before it submits.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], #checkout, .cart__checkout-button');
    if (!btn) return;
    if (btn.classList.contains('wholesale-blocked')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var el = messageEl();
      if (el) { el.hidden = false; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  }, true);

  // Product page: minimum 4 per design, then single units.
  function applyProductQtyRules() {
    var onProduct = document.querySelector('main[data-template^="product"]');
    if (!onProduct) return;
    var inputs = document.querySelectorAll('.quantity__input, input[name="quantity"]');
    Array.prototype.forEach.call(inputs, function (input) {
      if (input.closest('cart-items') || input.closest('cart-drawer-items')) return;
      input.setAttribute('min', CASE_PACK);
      input.setAttribute('step', 1);
      if (!input.value || parseInt(input.value, 10) < CASE_PACK) input.value = CASE_PACK;
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10) || CASE_PACK;
        if (v < CASE_PACK) v = CASE_PACK;
        input.value = v;
      });
    });
  }

  function init() {
    applyProductQtyRules();
    validate();

    var root = document.querySelector('#MainContent') || document.body;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(validate, 250);
    }).observe(root, { childList: true, subtree: true });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, validate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
